import { Link, Skeleton, Stack, TableCell, TableRow, Typography } from "@mui/material"

import { PriceDisplay } from "../PriceDisplay"
import { TokenAvatar } from "../TokenAvatar"
import type { Pool } from "@/api/pools-api"

import { useTokenInfo } from "@/hooks/use-token-info"
import { PoolOverview } from "@/types"
import FeeDisplay from "../FeeDisplay"

export default function PoolRow({
  pool,
  overview,
}: {
  pool: Pool
  overview?: PoolOverview | null
}) {
  const [baseTokenInfo] = useTokenInfo(pool.baseToken)
  const [quoteTokenInfo] = useTokenInfo(pool.quoteToken)
  if (!baseTokenInfo || !quoteTokenInfo) return null

  return (
    <TableRow key={pool.id}>
      <TableCell
        sx={{
          padding: 2,
        }}
      >
        <Link
          href={`/#/pool/${pool.id}`}
          sx={{
            textDecoration: "none",
          }}
        >
          <Stack direction="row" spacing={0.5} alignItems="center">
            <TokenAvatar tokenId={pool.baseToken} />
            <TokenAvatar tokenId={pool.quoteToken} />
            <span>
              <Typography component="span" variant="inherit" fontWeight={500}>
                {baseTokenInfo.ticker}
              </Typography>
              <Typography
                component="span"
                color="text.secondary"
                variant="inherit"
                fontWeight={300}
              >
                /{quoteTokenInfo.ticker}
              </Typography>
              <FeeDisplay feebps={pool.pool_fee_bps} />
            </span>
          </Stack>
        </Link>
      </TableCell>
      <TableCell align="right">
        {overview === null ? (
          <Skeleton width={80} sx={{ display: "inline-block" }} />
        ) : !overview ? (
          "Unknown"
        ) : (
          <PriceDisplay amount={overview.volumeUsd} />
        )}
      </TableCell>
      <TableCell align="right">
        {overview === null ? (
          <Skeleton width={80} sx={{ display: "inline-block" }} />
        ) : !overview ? (
          "Unknown"
        ) : (
          <PriceDisplay amount={overview.liquidityUsd} />
        )}
      </TableCell>
    </TableRow>
  )
}
